import { render } from "./EventDetailModal.vue?vue&type=template&id=6447d55a&ts=true"
import script from "./EventDetailModal.vue?vue&type=script&lang=ts"
export * from "./EventDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__